var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPassword = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9319 19.9055L16.6288 22.2689C16.0874 22.3187 15.5438 22.3437 15 22.3438C8.75992 22.3438 3.28289 19.0964 0.34617 14.2375C0.119529 13.8625 0 13.4352 0 13C0 12.5648 0.119529 12.1375 0.34617 11.7625C1.59737 9.69233 3.31039 7.91452 5.34742 6.55551L8.32018 10.6962C8.05919 11.4167 7.91669 12.1919 7.91669 13C7.91669 16.7952 11.0487 19.8698 14.9319 19.9055ZM29.6539 14.2375C28.0045 16.9664 25.5525 19.1867 22.6135 20.6093L22.6141 20.6101L24.774 23.6163C25.1698 24.1678 25.0323 24.9275 24.4667 25.3134L23.7839 25.7796C23.2182 26.1656 22.4391 26.0315 22.0432 25.48L5.22606 2.38367C4.83023 1.83218 4.96773 1.07249 5.53336 0.686555L6.21617 0.220382C6.78179 -0.165556 7.56096 -0.0314936 7.95679 0.519992L10.615 4.20758C12.0146 3.848 13.4847 3.65625 15 3.65625C21.2401 3.65625 26.7172 6.90367 29.6539 11.7625C29.8805 12.1375 30 12.5648 30 13C30 13.4353 29.8805 13.8625 29.6539 14.2375ZM22.0834 13C22.0834 9.18259 18.9147 6.09376 15 6.09376C14.0657 6.09376 13.1742 6.27012 12.3579 6.58999L13.363 7.96404C14.7104 7.5491 16.2299 7.65107 17.5505 8.34033H17.549C16.3172 8.34033 15.3188 9.3138 15.3188 10.5148C15.3188 11.7145 16.316 12.6892 17.549 12.6892C18.7807 12.6892 19.7792 11.7158 19.7792 10.5148V10.5133C20.7407 12.2647 20.6288 14.4698 19.3495 16.1475V16.148L20.3554 17.5222C21.4321 16.311 22.0834 14.7304 22.0834 13ZM13.6466 18.1151L9.60856 12.4907C9.34742 15.151 11.1353 17.4852 13.6466 18.1151Z",
    fill: "#333333",
    fillOpacity: 0.15
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPassword, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/password.95431d60.svg";
export { ForwardRef as ReactComponent };